import { Injectable, signal, WritableSignal, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, tap, map, finalize } from 'rxjs/operators';
import { User } from '@app/types';
import { ApiResponse } from '@app/types';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    private readonly http = inject(HttpClient);

    private _users: WritableSignal<User[]> = signal([]);
    public readonly users = this._users.asReadonly();

    private _isLoading: WritableSignal<boolean> = signal(true);
    public readonly isLoadingSignal = this._isLoading.asReadonly();

    private readonly API_URL = environment.API_URL;

    constructor() {
        this.loadUsers(true).subscribe();
    }

    loadUsers(forceRefresh: boolean = true): Observable<User[]> {
        this._isLoading.set(true);
        const body = { filters: {}, limit: 1000, offset: 0 };
        return this.http.post<ApiResponse<User>>(`${this.API_URL}/users/read`, body).pipe(
            tap((response) => {
                this._users.set(response.data);
            }),
            map((response) => response.data),
            catchError((err) => {
                console.error('Error fetching users from API', err);
                this._users.set([]);
                return throwError(() => err);
            }),
            finalize(() => this._isLoading.set(false))
        );
    }

}
